import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
serviceWorkerRegistration.register();
